import React from "react";
import Logo from "./Logo";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import HelpIcon from "@material-ui/icons/Help";

export default function Nav() {
  return (
    <div className="child1">
      <div className="logo">
        <Logo />
      </div>

      <div className="orders">
        <div className="whatshotIcon">
          <WhatshotIcon />
          <div className="order-text">
            <a href="/Order">ORDERS</a>
          </div>
        </div>
      </div>

      <div className="menu">
        <div className="MenuBookIcon">
          <MenuBookIcon />
          <div className="menu-text">
            <a href="/Order">MENU</a>
          </div>
        </div>
      </div>

      <div className="metrices">
        <div className="AssessmentIcon">
          <AssessmentIcon />
          <div className="metrices-text">
            <a href="/Order">METRICES</a>
          </div>
        </div>
      </div>

      <div className="discounts">
        <div className="AttachMoneyIcon">
          <AttachMoneyIcon />
          <div className="discount-text">
            <a href="/Order">DISCOUNT</a>
          </div>
        </div>
      </div>

      <div className="profile">
        <div className="AccountCircleIcon">
          <AccountCircleIcon />
          <div className="profile-text">
            <a href="/Order">PROFILE</a>
          </div>
        </div>
      </div>

      <div className="help">
        <div className="HelpIcon">
          <HelpIcon />
          <div className="help-text">
            <a href="/Order">HELP</a>
          </div>
        </div>
      </div>
    </div>
  );
}
